import React from "react";
import { Fingerprint, Sparkles, Compass } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Individuality",
  description: "We believe no two journeys should be alike. Your itinerary is hand-crafted to reflect your unique personality, pace, and passions.",
  icon: Fingerprint
}, {
  title: "Inspiration",
  description: "Drawing from deep local knowledge and hidden secrets, we spark ideas that transform a simple trip into a life-changing narrative.",
  icon: Sparkles
}, {
  title: "Imagination",
  description: "Dream without limits. We handle the logistics of the impossible, turning your wildest travel fantasies into seamless reality.",
  icon: Compass
}];
export default function CuratedTravelModalities() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}